import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { SiInstagram, SiLinkedin } from "react-icons/si";

const Footer = () => {
    return (
        <motion.footer
            className="bg-gradient-to-r from-cocoa-600 to-cocoa-500 text-white py-8 md:py-10 lg:py-12"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <div className="container mx-auto px-4">
                <div className="flex flex-col items-center space-y-6 md:space-y-8">
                    {/* Logo/Titre */}
                    <motion.h2
                        className="text-3xl md:text-4xl lg:text-5xl font-bold"
                        initial={{ y: -20 }}
                        animate={{ y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        ISILIVING
                    </motion.h2>

                    {/* Adresse et Contact */}
                    <motion.address
                        className="text-center text-sm md:text-base lg:text-lg not-italic"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.5, duration: 0.5 }}
                    >
                        <p className="mb-2">724 avenue du club hippique</p>
                        <p className="mb-2">13100 Aix-en-Provence</p>
                        <a href="mailto:contact@isiliving.fr"
                            className="block mb-2 hover:text-brandy-rose transition-colors">
                            contact@isiliving.fr
                        </a>
                        <a
                            href="tel:0442951451"
                            className="block hover:text-brandy-rose transition-colors"
                        >
                            04 42 95 14 51
                        </a>
                    </motion.address>

                    {/* Bouton Plan d'accès */}
                    <Link to="https://www.google.fr/maps/place/ISILIVING/@43.5131654,5.4245674,17z/">
                        <motion.button
                            className="bg-brandy-rose text-white py-2 px-6 rounded-full 
                                     hover:bg-white hover:text-brandy-rose transition-colors
                                     text-sm md:text-base lg:text-lg"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            Plan d'accès
                        </motion.button>
                    </Link>

                    {/* Réseaux sociaux */}
                    <div className="flex justify-center space-x-6 mt-6">
                        {SOCIAL_LINKS.map((social, index) => (
                            <motion.a
                                key={index}
                                href={social.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-2xl md:text-3xl hover:text-brandy-rose transition-colors"
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                            >
                                <social.Component />
                            </motion.a>
                        ))}
                    </div>
                </div>
            </div>
        </motion.footer>
    );
};

const SOCIAL_LINKS = [
    {
        Component: SiInstagram,
        href: "https://www.instagram.com/isilivingofficial/",
    },
    {
        Component: SiLinkedin,
        href: "https://fr.linkedin.com/company/isiliving",
    },
];

export default Footer;